import utils from "../utils";

function init() {
	animeText();

	pageLoaded();
	setPathLenght();

}

function pageLoaded(){
	window.onload = function() {
		var body = document.querySelector('body');
		body.classList.add('page-loaded');
	};
}

function setPathLenght(){
	var paths = document.querySelectorAll('.line-wrapper .line polyline');

	if(paths.length > 0){

		utils.forEach(paths, function (index, path) {

			//console.log(path);

			var pathLength = path.getTotalLength(); // eslint-disable-line
			//console.log(pathLength);

		});
	}
}

function enterInViewportElem(elem) { // eslint-disable-line
	var distance = elem.getBoundingClientRect(),
		windowHeight = window.innerHeight;
	return (
		distance.top <= (windowHeight / 3) * 2
	);
}

function animeText() {
	var elems = document.querySelectorAll(".enter-animation");

	if (elems.length > 0) {
		utils.forEach(elems, function (index, elem) {

			if (enterInViewportElem(elem)) {
				// Controlla se l'elemento ha l'attributo "delay"
				var delay = elem.getAttribute('smx-delay');

				// Aggiungi il ritardo all'animazione se l'attributo "delay" è presente e valido
				if (delay && !isNaN(delay)) {
					setTimeout(function () {
						elem.classList.add("in-view");
					}, parseInt(delay));
				} else {
					// Se non c'è attributo "delay" o non è valido, aggiungi immediatamente la classe
					elem.classList.add("in-view");
				}
			}
		});
	}

	window.addEventListener(
		"scroll",
		function () {
			var elems = document.querySelectorAll(".enter-animation");

			if (elems.length > 0) {
				utils.forEach(elems, function (index, elem) {
				
					if (enterInViewportElem(elem)) {
						// Controlla se l'elemento ha l'attributo "delay"
						var delay = elem.getAttribute('smx-delay');

						// Aggiungi il ritardo all'animazione se l'attributo "delay" è presente e valido
						if (delay && !isNaN(delay)) {
							setTimeout(function () {
								elem.classList.add("in-view");
							}, parseInt(delay));
						} else {
							// Se non c'è attributo "delay" o non è valido, aggiungi immediatamente la classe
							elem.classList.add("in-view");
						}
					}

				});
			}
		},
		false
	)

}

function smxBoxCompositionAnimation(animation_type){



	const box_elements = {
		'prod1': document.getElementById('smx-prod-1'),
		'prod2' : document.getElementById('smx-prod-2'),
		'prod3' : document.getElementById('smx-prod-3'),
		'box_cap' : document.getElementById('smx-box-cap'),
		'box_shadow' : document.getElementById('smx-box-cap-shadow'),
	};

	if('enter' == animation_type){

		var time = 300;
	
	
		for( let i=0; i<4; i++ ){
	
	
			if(Object.keys(box_elements)[i] == 'box_cap'){
				time = 450;
			}
	
			setTimeout( function(){
				box_elements[Object.keys(box_elements)[i]].classList.add('visible');
		
				if(Object.keys(box_elements)[i] == 'box_cap'){
					box_elements.box_shadow.classList.add('visible');
				}
	
			}, time * i  );
	
		}
	}else if('leave' == animation_type ){

		Object.entries(box_elements).forEach(([key, value]) => { // eslint-disable-line
			value.classList.remove('visible');
		})

	}


	
	

}

export default { init, smxBoxCompositionAnimation };
